import { IAppointmentType } from './appointment-type.interface';
export interface IPoolChart {
    appointmentTypeId:number;
    appointmentType:IAppointmentType;
}
